<template>
<div class="chapter">
<div class="inner_page">
<p class="smallcaps">Nach Mitteilungen des Chefs der New Yorker Geheimpolizei</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec000001.vue?31087062